import { ICON_DEFAULT_SIZE } from '@constants/icons';
import { IconProps } from '@models/icons';

function PlusCircleLine({ size = ICON_DEFAULT_SIZE, color = 'currentColor', ...rest }: IconProps) {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
            {...rest} >
            <circle cx="12" cy="12" r="9.3" stroke={color} strokeWidth="1.4"/>
            <path d="M12 8V16M16 12H8" stroke={color} strokeWidth="1.4" strokeLinecap="round"/>
        </svg>
    );
}

export default PlusCircleLine;
